import noodleApiClient, { ApiDefinition } from '@noodleApi';

type THIS_API = ApiDefinition['/creators/{id}/bookings']['GET'];
type Input = THIS_API['query'] & THIS_API['params'];
type Output = THIS_API['response'];

const getBookingsForCreator = async ({ startDate, endDate, creatorId, teamMemberPersonId, page, perPage, arePast }: Input): Promise<Output> => {
  const response = await noodleApiClient.get(`creators/${creatorId}/bookings` , {
    params: {
      arePast,
      endDate,
      page,
      perPage,
      startDate,
      teamMemberPersonId,
    },
  });
  return response.data;
};

export default getBookingsForCreator;
